import Skills from './components/Skills';
import Projects from './components/Projects';
import Hero from './components/Hero';
import Header from './components/Header';
import About from './components/About';
import Contact from './components/Contact';
import imageUrlBuilder from '@sanity/image-url';
import { sanityClient } from './client';
import { useEffect, useState } from 'react';
import { Circles, Rings } from 'react-loader-spinner';

function App() {
  const [pageInfo, setPageInfo] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type=="pageInfo"]{
        ProfilePic,
        backgroundinfo,
        email,
        name,
        phoneNumber,
        role,
        ProfilePic{
          asset
      },
        heroImage{
          asset
      }
    }`
      )
      .then((data) => setPageInfo(data))
      .catch(console.error);
  }, []);
  const builder = imageUrlBuilder(sanityClient);
  function urlFor(source) {
    return builder.image(source);
  }
  //const imageUrl = builder.image(imageField).width(800).height(600).url();
  //const { backgroundin(fo, email, name, phoneNumber, role } = pageInfo;
  if (!pageInfo)
    return (
      <div className="flex flex-col items-center justify-center gap-3 W-screen h-screen bg-[#fcde67] text-white">
        <Circles height={50} width={50} color="#5bccf6" />
        <p className="tracking-[5px] w-3/4 text-center font-bold">
          Please Wait! Loading Resources For You, This Will take seconds.
        </p>
      </div>
    );
  const herourl = urlFor(pageInfo[0]?.ProfilePic?.asset?._ref).url();
  const profileurl = urlFor(pageInfo[0]?.heroImage?.asset?._ref).url();

  return (
    <main className=" overflow-hidden  text-2xl bg-[#fcde67] text-white h-fit text-slate-500   scroll-y-hidden  snap-y snap-mandatory z-0 ">
      <Header />
      {/* Hero */}
      <section id="hero" className="snap-start">
        <Hero role={pageInfo[0]?.role} heroImage={herourl} />
      </section>
      <section id="about" className="snap-center">
        <About
          backgroundinfo={pageInfo[0]?.backgroundinfo}
          profileurl={profileurl}
        />
      </section>
      <section id="skills" className="snap-start">
        <Skills />
      </section>
      <section id="projects" className="snap-start">
        <Projects />
      </section>
      <section id="contact" className="snap-start">
        <Contact
          email={pageInfo[0]?.email}
          phoneNumber={pageInfo[0]?.phoneNumber}
        />
      </section>
      <footer className="text-center text-bold text-base font-bold text-black  cursor-pointer">
        <a href="#hero">
          <img
            src="./assets/favicon.png"
            alt="jaguarlogo"
            className="fixed w-5 h-5 rounded-full filter grayscale object-contain hover:grayscale-0 bottom-0 right-10"
          />
        </a>
        <p>Jackon.Code&copy;2024</p>
      </footer>
    </main>
  );
}

export default App;
